
// // Get rid of unnecessary Three.js warnings.
// console.clear();
// const consoleWarn = console.warn;
// console.warn = (...args) => {
//   if (args[0].indexOf("THREE.") == 0)
//     return;
//   consoleWarn.apply(console, args);
// }

if (document.location.protocol != "https:") {
  document.location.protocol = "https:";
}

import React from 'react';
import ReactDOM from 'react-dom';
import { initWhiteLabel } from './whitelabel';
import {App} from './Components/App'
import { measureRefreshRate } from './refreshRate';
import { initUrlData } from './urlData';

initWhiteLabel().then(() => {
  initUrlData();
  measureRefreshRate();
  ReactDOM.render(
    <React.StrictMode>
      <App/>
    </React.StrictMode>,
    document.getElementById("app-include-content")
  );
});